import { render, staticRenderFns } from "./Search-Address.vue?vue&type=template&id=3f88953e&scoped=true"
import script from "./Search-Address.vue?vue&type=script&lang=js"
export * from "./Search-Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88953e",
  null
  
)

export default component.exports